import { useCommand } from '@cqrs/vue-composables-cqrs'
import * as c from '@Integrations/Datasets/commands-core'
import { isRef, ref, Ref } from 'vue'

export function useAddDatasetItemCommandV1(
	id?: string | Ref<string> | (() => string), 
	organizationUnitId?: string | Ref<string> | (() => string), 
	updatedBy?: string | Ref<string> | (() => string), 
	idPropertyName?: string | Ref<string> | (() => string), 
	itemId?: string | Ref<string> | (() => string), 
	runId?: string | null | Ref<string | null> | (() => string | null), 
) 
{
	const _id = isRef<string>(id) ? id : ref<string>((typeof id === 'function') ? id() : id)
	const _organizationUnitId = isRef<string>(organizationUnitId) ? organizationUnitId : ref<string>((typeof organizationUnitId === 'function') ? organizationUnitId() : organizationUnitId)
	const _updatedBy = isRef<string>(updatedBy) ? updatedBy : ref<string>((typeof updatedBy === 'function') ? updatedBy() : updatedBy)
	const _idPropertyName = isRef<string>(idPropertyName) ? idPropertyName : ref<string>((typeof idPropertyName === 'function') ? idPropertyName() : idPropertyName)
	const _itemId = isRef<string>(itemId) ? itemId : ref<string>((typeof itemId === 'function') ? itemId() : itemId)
	const _runId = isRef<string | null>(runId) ? runId : ref<string | null>((typeof runId === 'function') ? runId() : runId)

	const result = {
		id: _id,
		organizationUnitId: _organizationUnitId,
		updatedBy: _updatedBy,
		idPropertyName: _idPropertyName,
		itemId: _itemId,
		runId: _runId,

		...useCommand(() => {
			if (typeof id === 'function') { _id.value = id() }
			if (typeof organizationUnitId === 'function') { _organizationUnitId.value = organizationUnitId() }
			if (typeof updatedBy === 'function') { _updatedBy.value = updatedBy() }
			if (typeof idPropertyName === 'function') { _idPropertyName.value = idPropertyName() }
			if (typeof itemId === 'function') { _itemId.value = itemId() }
			if (typeof runId === 'function') { _runId.value = runId() }

			return new c.AddDatasetItemCommandV1(_id.value, _organizationUnitId.value, _updatedBy.value, _idPropertyName.value, _itemId.value, _runId.value)
		})
	}

	return {
		...result,
		authorizedAddDatasetItemCommandV1: result.authorized,
		addDatasetItemCommandV1: result.command,
		completedAddDatasetItemCommandV1: result.completed,
		errorAddDatasetItemCommandV1: result.error,
		invokeAddDatasetItemCommandV1: result.invoke,
		invokingAddDatasetItemCommandV1: result.invoking,
		succeedAddDatasetItemCommandV1: result.succeed,
		validationErrorsAddDatasetItemCommandV1: result.validationErrors,
		onSucceedAddDatasetItemCommandV1: result.onSucceed,
	}
}

export function useAddDatasetItemCommandV2(
	id?: string | Ref<string> | (() => string), 
	organizationUnitId?: string | Ref<string> | (() => string), 
	updatedBy?: string | Ref<string> | (() => string), 
	itemId?: any | Ref<any> | (() => any), 
	runId?: string | null | Ref<string | null> | (() => string | null), 
) 
{
	const _id = isRef<string>(id) ? id : ref<string>((typeof id === 'function') ? id() : id)
	const _organizationUnitId = isRef<string>(organizationUnitId) ? organizationUnitId : ref<string>((typeof organizationUnitId === 'function') ? organizationUnitId() : organizationUnitId)
	const _updatedBy = isRef<string>(updatedBy) ? updatedBy : ref<string>((typeof updatedBy === 'function') ? updatedBy() : updatedBy)
	const _itemId = isRef<any>(itemId) ? itemId : ref<any>((typeof itemId === 'function') ? itemId() : itemId)
	const _runId = isRef<string | null>(runId) ? runId : ref<string | null>((typeof runId === 'function') ? runId() : runId)

	const result = {
		id: _id,
		organizationUnitId: _organizationUnitId,
		updatedBy: _updatedBy,
		itemId: _itemId,
		runId: _runId,

		...useCommand(() => {
			if (typeof id === 'function') { _id.value = id() }
			if (typeof organizationUnitId === 'function') { _organizationUnitId.value = organizationUnitId() }
			if (typeof updatedBy === 'function') { _updatedBy.value = updatedBy() }
			if (typeof itemId === 'function') { _itemId.value = itemId() }
			if (typeof runId === 'function') { _runId.value = runId() }

			return new c.AddDatasetItemCommandV2(_id.value, _organizationUnitId.value, _updatedBy.value, _itemId.value, _runId.value)
		})
	}

	return {
		...result,
		authorizedAddDatasetItemCommandV2: result.authorized,
		addDatasetItemCommandV2: result.command,
		completedAddDatasetItemCommandV2: result.completed,
		errorAddDatasetItemCommandV2: result.error,
		invokeAddDatasetItemCommandV2: result.invoke,
		invokingAddDatasetItemCommandV2: result.invoking,
		succeedAddDatasetItemCommandV2: result.succeed,
		validationErrorsAddDatasetItemCommandV2: result.validationErrors,
		onSucceedAddDatasetItemCommandV2: result.onSucceed,
	}
}

export function useChangeDatasetItemPropertyCommandV1(
	id?: string | Ref<string> | (() => string), 
	organizationUnitId?: string | Ref<string> | (() => string), 
	updatedBy?: string | Ref<string> | (() => string), 
	idPropertyName?: string | Ref<string> | (() => string), 
	itemId?: string | Ref<string> | (() => string), 
	propertyName?: string | Ref<string> | (() => string), 
	oldValue?: any | Ref<any> | (() => any), 
	newValue?: any | Ref<any> | (() => any), 
	runId?: string | null | Ref<string | null> | (() => string | null), 
) 
{
	const _id = isRef<string>(id) ? id : ref<string>((typeof id === 'function') ? id() : id)
	const _organizationUnitId = isRef<string>(organizationUnitId) ? organizationUnitId : ref<string>((typeof organizationUnitId === 'function') ? organizationUnitId() : organizationUnitId)
	const _updatedBy = isRef<string>(updatedBy) ? updatedBy : ref<string>((typeof updatedBy === 'function') ? updatedBy() : updatedBy)
	const _idPropertyName = isRef<string>(idPropertyName) ? idPropertyName : ref<string>((typeof idPropertyName === 'function') ? idPropertyName() : idPropertyName)
	const _itemId = isRef<string>(itemId) ? itemId : ref<string>((typeof itemId === 'function') ? itemId() : itemId)
	const _propertyName = isRef<string>(propertyName) ? propertyName : ref<string>((typeof propertyName === 'function') ? propertyName() : propertyName)
	const _oldValue = isRef<any>(oldValue) ? oldValue : ref<any>((typeof oldValue === 'function') ? oldValue() : oldValue)
	const _newValue = isRef<any>(newValue) ? newValue : ref<any>((typeof newValue === 'function') ? newValue() : newValue)
	const _runId = isRef<string | null>(runId) ? runId : ref<string | null>((typeof runId === 'function') ? runId() : runId)

	const result = {
		id: _id,
		organizationUnitId: _organizationUnitId,
		updatedBy: _updatedBy,
		idPropertyName: _idPropertyName,
		itemId: _itemId,
		propertyName: _propertyName,
		oldValue: _oldValue,
		newValue: _newValue,
		runId: _runId,

		...useCommand(() => {
			if (typeof id === 'function') { _id.value = id() }
			if (typeof organizationUnitId === 'function') { _organizationUnitId.value = organizationUnitId() }
			if (typeof updatedBy === 'function') { _updatedBy.value = updatedBy() }
			if (typeof idPropertyName === 'function') { _idPropertyName.value = idPropertyName() }
			if (typeof itemId === 'function') { _itemId.value = itemId() }
			if (typeof propertyName === 'function') { _propertyName.value = propertyName() }
			if (typeof oldValue === 'function') { _oldValue.value = oldValue() }
			if (typeof newValue === 'function') { _newValue.value = newValue() }
			if (typeof runId === 'function') { _runId.value = runId() }

			return new c.ChangeDatasetItemPropertyCommandV1(_id.value, _organizationUnitId.value, _updatedBy.value, _idPropertyName.value, _itemId.value, _propertyName.value, _oldValue.value, _newValue.value, _runId.value)
		})
	}

	return {
		...result,
		authorizedChangeDatasetItemPropertyCommandV1: result.authorized,
		changeDatasetItemPropertyCommandV1: result.command,
		completedChangeDatasetItemPropertyCommandV1: result.completed,
		errorChangeDatasetItemPropertyCommandV1: result.error,
		invokeChangeDatasetItemPropertyCommandV1: result.invoke,
		invokingChangeDatasetItemPropertyCommandV1: result.invoking,
		succeedChangeDatasetItemPropertyCommandV1: result.succeed,
		validationErrorsChangeDatasetItemPropertyCommandV1: result.validationErrors,
		onSucceedChangeDatasetItemPropertyCommandV1: result.onSucceed,
	}
}

export function useChangeDatasetItemPropertyCommandV2(
	id?: string | Ref<string> | (() => string), 
	organizationUnitId?: string | Ref<string> | (() => string), 
	updatedBy?: string | Ref<string> | (() => string), 
	itemId?: any | Ref<any> | (() => any), 
	propertyName?: string | Ref<string> | (() => string), 
	oldValue?: any | Ref<any> | (() => any), 
	newValue?: any | Ref<any> | (() => any), 
	runId?: string | null | Ref<string | null> | (() => string | null), 
) 
{
	const _id = isRef<string>(id) ? id : ref<string>((typeof id === 'function') ? id() : id)
	const _organizationUnitId = isRef<string>(organizationUnitId) ? organizationUnitId : ref<string>((typeof organizationUnitId === 'function') ? organizationUnitId() : organizationUnitId)
	const _updatedBy = isRef<string>(updatedBy) ? updatedBy : ref<string>((typeof updatedBy === 'function') ? updatedBy() : updatedBy)
	const _itemId = isRef<any>(itemId) ? itemId : ref<any>((typeof itemId === 'function') ? itemId() : itemId)
	const _propertyName = isRef<string>(propertyName) ? propertyName : ref<string>((typeof propertyName === 'function') ? propertyName() : propertyName)
	const _oldValue = isRef<any>(oldValue) ? oldValue : ref<any>((typeof oldValue === 'function') ? oldValue() : oldValue)
	const _newValue = isRef<any>(newValue) ? newValue : ref<any>((typeof newValue === 'function') ? newValue() : newValue)
	const _runId = isRef<string | null>(runId) ? runId : ref<string | null>((typeof runId === 'function') ? runId() : runId)

	const result = {
		id: _id,
		organizationUnitId: _organizationUnitId,
		updatedBy: _updatedBy,
		itemId: _itemId,
		propertyName: _propertyName,
		oldValue: _oldValue,
		newValue: _newValue,
		runId: _runId,

		...useCommand(() => {
			if (typeof id === 'function') { _id.value = id() }
			if (typeof organizationUnitId === 'function') { _organizationUnitId.value = organizationUnitId() }
			if (typeof updatedBy === 'function') { _updatedBy.value = updatedBy() }
			if (typeof itemId === 'function') { _itemId.value = itemId() }
			if (typeof propertyName === 'function') { _propertyName.value = propertyName() }
			if (typeof oldValue === 'function') { _oldValue.value = oldValue() }
			if (typeof newValue === 'function') { _newValue.value = newValue() }
			if (typeof runId === 'function') { _runId.value = runId() }

			return new c.ChangeDatasetItemPropertyCommandV2(_id.value, _organizationUnitId.value, _updatedBy.value, _itemId.value, _propertyName.value, _oldValue.value, _newValue.value, _runId.value)
		})
	}

	return {
		...result,
		authorizedChangeDatasetItemPropertyCommandV2: result.authorized,
		changeDatasetItemPropertyCommandV2: result.command,
		completedChangeDatasetItemPropertyCommandV2: result.completed,
		errorChangeDatasetItemPropertyCommandV2: result.error,
		invokeChangeDatasetItemPropertyCommandV2: result.invoke,
		invokingChangeDatasetItemPropertyCommandV2: result.invoking,
		succeedChangeDatasetItemPropertyCommandV2: result.succeed,
		validationErrorsChangeDatasetItemPropertyCommandV2: result.validationErrors,
		onSucceedChangeDatasetItemPropertyCommandV2: result.onSucceed,
	}
}

export function useClearDatasetItemsCommandV1(
	id?: string | Ref<string> | (() => string), 
	organizationUnitId?: string | Ref<string> | (() => string), 
	updatedBy?: string | Ref<string> | (() => string), 
	updatedAt?: any | Ref<any> | (() => any), 
) 
{
	const _id = isRef<string>(id) ? id : ref<string>((typeof id === 'function') ? id() : id)
	const _organizationUnitId = isRef<string>(organizationUnitId) ? organizationUnitId : ref<string>((typeof organizationUnitId === 'function') ? organizationUnitId() : organizationUnitId)
	const _updatedBy = isRef<string>(updatedBy) ? updatedBy : ref<string>((typeof updatedBy === 'function') ? updatedBy() : updatedBy)
	const _updatedAt = isRef<any>(updatedAt) ? updatedAt : ref<any>((typeof updatedAt === 'function') ? updatedAt() : updatedAt)

	const result = {
		id: _id,
		organizationUnitId: _organizationUnitId,
		updatedBy: _updatedBy,
		updatedAt: _updatedAt,

		...useCommand(() => {
			if (typeof id === 'function') { _id.value = id() }
			if (typeof organizationUnitId === 'function') { _organizationUnitId.value = organizationUnitId() }
			if (typeof updatedBy === 'function') { _updatedBy.value = updatedBy() }
			if (typeof updatedAt === 'function') { _updatedAt.value = updatedAt() }

			return new c.ClearDatasetItemsCommandV1(_id.value, _organizationUnitId.value, _updatedBy.value, _updatedAt.value)
		})
	}

	return {
		...result,
		authorizedClearDatasetItemsCommandV1: result.authorized,
		clearDatasetItemsCommandV1: result.command,
		completedClearDatasetItemsCommandV1: result.completed,
		errorClearDatasetItemsCommandV1: result.error,
		invokeClearDatasetItemsCommandV1: result.invoke,
		invokingClearDatasetItemsCommandV1: result.invoking,
		succeedClearDatasetItemsCommandV1: result.succeed,
		validationErrorsClearDatasetItemsCommandV1: result.validationErrors,
		onSucceedClearDatasetItemsCommandV1: result.onSucceed,
	}
}

export function useCreateDatasetCommandV1(
	id?: string | Ref<string> | (() => string), 
	organizationUnitId?: string | Ref<string> | (() => string), 
	createdBy?: string | Ref<string> | (() => string), 
	name?: string | Ref<string> | (() => string), 
) 
{
	const _id = isRef<string>(id) ? id : ref<string>((typeof id === 'function') ? id() : id)
	const _organizationUnitId = isRef<string>(organizationUnitId) ? organizationUnitId : ref<string>((typeof organizationUnitId === 'function') ? organizationUnitId() : organizationUnitId)
	const _createdBy = isRef<string>(createdBy) ? createdBy : ref<string>((typeof createdBy === 'function') ? createdBy() : createdBy)
	const _name = isRef<string>(name) ? name : ref<string>((typeof name === 'function') ? name() : name)

	const result = {
		id: _id,
		organizationUnitId: _organizationUnitId,
		createdBy: _createdBy,
		name: _name,

		...useCommand(() => {
			if (typeof id === 'function') { _id.value = id() }
			if (typeof organizationUnitId === 'function') { _organizationUnitId.value = organizationUnitId() }
			if (typeof createdBy === 'function') { _createdBy.value = createdBy() }
			if (typeof name === 'function') { _name.value = name() }

			return new c.CreateDatasetCommandV1(_id.value, _organizationUnitId.value, _createdBy.value, _name.value)
		})
	}

	return {
		...result,
		authorizedCreateDatasetCommandV1: result.authorized,
		createDatasetCommandV1: result.command,
		completedCreateDatasetCommandV1: result.completed,
		errorCreateDatasetCommandV1: result.error,
		invokeCreateDatasetCommandV1: result.invoke,
		invokingCreateDatasetCommandV1: result.invoking,
		succeedCreateDatasetCommandV1: result.succeed,
		validationErrorsCreateDatasetCommandV1: result.validationErrors,
		onSucceedCreateDatasetCommandV1: result.onSucceed,
	}
}

export function useDeleteDatasetCommandV1(
	id?: string | Ref<string> | (() => string), 
	organizationUnitId?: string | Ref<string> | (() => string), 
	deletedBy?: string | Ref<string> | (() => string), 
) 
{
	const _id = isRef<string>(id) ? id : ref<string>((typeof id === 'function') ? id() : id)
	const _organizationUnitId = isRef<string>(organizationUnitId) ? organizationUnitId : ref<string>((typeof organizationUnitId === 'function') ? organizationUnitId() : organizationUnitId)
	const _deletedBy = isRef<string>(deletedBy) ? deletedBy : ref<string>((typeof deletedBy === 'function') ? deletedBy() : deletedBy)

	const result = {
		id: _id,
		organizationUnitId: _organizationUnitId,
		deletedBy: _deletedBy,

		...useCommand(() => {
			if (typeof id === 'function') { _id.value = id() }
			if (typeof organizationUnitId === 'function') { _organizationUnitId.value = organizationUnitId() }
			if (typeof deletedBy === 'function') { _deletedBy.value = deletedBy() }

			return new c.DeleteDatasetCommandV1(_id.value, _organizationUnitId.value, _deletedBy.value)
		})
	}

	return {
		...result,
		authorizedDeleteDatasetCommandV1: result.authorized,
		deleteDatasetCommandV1: result.command,
		completedDeleteDatasetCommandV1: result.completed,
		errorDeleteDatasetCommandV1: result.error,
		invokeDeleteDatasetCommandV1: result.invoke,
		invokingDeleteDatasetCommandV1: result.invoking,
		succeedDeleteDatasetCommandV1: result.succeed,
		validationErrorsDeleteDatasetCommandV1: result.validationErrors,
		onSucceedDeleteDatasetCommandV1: result.onSucceed,
	}
}

export function usePermanentDeleteDatasetCommandV1(
	id?: string | Ref<string> | (() => string), 
) 
{
	const _id = isRef<string>(id) ? id : ref<string>((typeof id === 'function') ? id() : id)

	const result = {
		id: _id,

		...useCommand(() => {
			if (typeof id === 'function') { _id.value = id() }

			return new c.PermanentDeleteDatasetCommandV1(_id.value)
		})
	}

	return {
		...result,
		authorizedPermanentDeleteDatasetCommandV1: result.authorized,
		permanentDeleteDatasetCommandV1: result.command,
		completedPermanentDeleteDatasetCommandV1: result.completed,
		errorPermanentDeleteDatasetCommandV1: result.error,
		invokePermanentDeleteDatasetCommandV1: result.invoke,
		invokingPermanentDeleteDatasetCommandV1: result.invoking,
		succeedPermanentDeleteDatasetCommandV1: result.succeed,
		validationErrorsPermanentDeleteDatasetCommandV1: result.validationErrors,
		onSucceedPermanentDeleteDatasetCommandV1: result.onSucceed,
	}
}

export function useRemoveDatasetItemCommandV1(
	id?: string | Ref<string> | (() => string), 
	organizationUnitId?: string | Ref<string> | (() => string), 
	updatedBy?: string | Ref<string> | (() => string), 
	updatedAt?: any | Ref<any> | (() => any), 
	idPropertyName?: string | Ref<string> | (() => string), 
	itemId?: string | Ref<string> | (() => string), 
	runId?: string | null | Ref<string | null> | (() => string | null), 
) 
{
	const _id = isRef<string>(id) ? id : ref<string>((typeof id === 'function') ? id() : id)
	const _organizationUnitId = isRef<string>(organizationUnitId) ? organizationUnitId : ref<string>((typeof organizationUnitId === 'function') ? organizationUnitId() : organizationUnitId)
	const _updatedBy = isRef<string>(updatedBy) ? updatedBy : ref<string>((typeof updatedBy === 'function') ? updatedBy() : updatedBy)
	const _updatedAt = isRef<any>(updatedAt) ? updatedAt : ref<any>((typeof updatedAt === 'function') ? updatedAt() : updatedAt)
	const _idPropertyName = isRef<string>(idPropertyName) ? idPropertyName : ref<string>((typeof idPropertyName === 'function') ? idPropertyName() : idPropertyName)
	const _itemId = isRef<string>(itemId) ? itemId : ref<string>((typeof itemId === 'function') ? itemId() : itemId)
	const _runId = isRef<string | null>(runId) ? runId : ref<string | null>((typeof runId === 'function') ? runId() : runId)

	const result = {
		id: _id,
		organizationUnitId: _organizationUnitId,
		updatedBy: _updatedBy,
		updatedAt: _updatedAt,
		idPropertyName: _idPropertyName,
		itemId: _itemId,
		runId: _runId,

		...useCommand(() => {
			if (typeof id === 'function') { _id.value = id() }
			if (typeof organizationUnitId === 'function') { _organizationUnitId.value = organizationUnitId() }
			if (typeof updatedBy === 'function') { _updatedBy.value = updatedBy() }
			if (typeof updatedAt === 'function') { _updatedAt.value = updatedAt() }
			if (typeof idPropertyName === 'function') { _idPropertyName.value = idPropertyName() }
			if (typeof itemId === 'function') { _itemId.value = itemId() }
			if (typeof runId === 'function') { _runId.value = runId() }

			return new c.RemoveDatasetItemCommandV1(_id.value, _organizationUnitId.value, _updatedBy.value, _updatedAt.value, _idPropertyName.value, _itemId.value, _runId.value)
		})
	}

	return {
		...result,
		authorizedRemoveDatasetItemCommandV1: result.authorized,
		removeDatasetItemCommandV1: result.command,
		completedRemoveDatasetItemCommandV1: result.completed,
		errorRemoveDatasetItemCommandV1: result.error,
		invokeRemoveDatasetItemCommandV1: result.invoke,
		invokingRemoveDatasetItemCommandV1: result.invoking,
		succeedRemoveDatasetItemCommandV1: result.succeed,
		validationErrorsRemoveDatasetItemCommandV1: result.validationErrors,
		onSucceedRemoveDatasetItemCommandV1: result.onSucceed,
	}
}

export function useRemoveDatasetItemCommandV2(
	id?: string | Ref<string> | (() => string), 
	organizationUnitId?: string | Ref<string> | (() => string), 
	updatedBy?: string | Ref<string> | (() => string), 
	updatedAt?: any | Ref<any> | (() => any), 
	itemId?: any | Ref<any> | (() => any), 
	runId?: string | null | Ref<string | null> | (() => string | null), 
) 
{
	const _id = isRef<string>(id) ? id : ref<string>((typeof id === 'function') ? id() : id)
	const _organizationUnitId = isRef<string>(organizationUnitId) ? organizationUnitId : ref<string>((typeof organizationUnitId === 'function') ? organizationUnitId() : organizationUnitId)
	const _updatedBy = isRef<string>(updatedBy) ? updatedBy : ref<string>((typeof updatedBy === 'function') ? updatedBy() : updatedBy)
	const _updatedAt = isRef<any>(updatedAt) ? updatedAt : ref<any>((typeof updatedAt === 'function') ? updatedAt() : updatedAt)
	const _itemId = isRef<any>(itemId) ? itemId : ref<any>((typeof itemId === 'function') ? itemId() : itemId)
	const _runId = isRef<string | null>(runId) ? runId : ref<string | null>((typeof runId === 'function') ? runId() : runId)

	const result = {
		id: _id,
		organizationUnitId: _organizationUnitId,
		updatedBy: _updatedBy,
		updatedAt: _updatedAt,
		itemId: _itemId,
		runId: _runId,

		...useCommand(() => {
			if (typeof id === 'function') { _id.value = id() }
			if (typeof organizationUnitId === 'function') { _organizationUnitId.value = organizationUnitId() }
			if (typeof updatedBy === 'function') { _updatedBy.value = updatedBy() }
			if (typeof updatedAt === 'function') { _updatedAt.value = updatedAt() }
			if (typeof itemId === 'function') { _itemId.value = itemId() }
			if (typeof runId === 'function') { _runId.value = runId() }

			return new c.RemoveDatasetItemCommandV2(_id.value, _organizationUnitId.value, _updatedBy.value, _updatedAt.value, _itemId.value, _runId.value)
		})
	}

	return {
		...result,
		authorizedRemoveDatasetItemCommandV2: result.authorized,
		removeDatasetItemCommandV2: result.command,
		completedRemoveDatasetItemCommandV2: result.completed,
		errorRemoveDatasetItemCommandV2: result.error,
		invokeRemoveDatasetItemCommandV2: result.invoke,
		invokingRemoveDatasetItemCommandV2: result.invoking,
		succeedRemoveDatasetItemCommandV2: result.succeed,
		validationErrorsRemoveDatasetItemCommandV2: result.validationErrors,
		onSucceedRemoveDatasetItemCommandV2: result.onSucceed,
	}
}

